/*
 * @Author: yeyimei
 * @Date: 2023-08-24 09:55:48
 * @LastEditTime: 2025-05-28 14:06:50
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\router\travel.routes.js
 */
export default [
  {
    path: '/tc-travel',
    name: 'tcTravel',
    component: () => import('@/views/travel/tc-travel.vue'),
    meta: {
      title: '出行订票',
      showName: true,
    },
  },
]
